// Global business rules for Ecom Seekho wholesale store.

// Minimum order quantity per product line (wholesale MOQ).
export const MIN_QTY = 12;

// Enforce MOQ on a raw quantity value.
export const clampQty = (q) => {
  const n = parseInt(q) || 0;
  if (n <= 0) return 0; // 0 means "remove from cart"
  return Math.max(MIN_QTY, n);
};
